import { returnPath } from '~/features/common/utils/navigation/returnPath';


export const getIdPath = returnPath("/system/agents/weather-station/:id");
export const getIndexPath = returnPath("/system/agents/weather-station");